import { useSelector } from './types'
import { useGetCustomerCoupons } from './vouchers/customerVouchers.query'

function useHasInCompletedVouchers() {
    const totals = useSelector((state) => state.cart.totals)
    const subTotal = totals?.subtotal ?? 0
    const { data: vouchers } = useGetCustomerCoupons()

    if (!vouchers || !vouchers.length) {
        return false
    }

    return vouchers.some((voucher) =>
        voucher.minimalOrderAmount
            ? voucher.minimalOrderAmount.value - subTotal > 0
            : false,
    )
}

export default useHasInCompletedVouchers
